import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { NotificationAction, NotificationEvent, SaleRequestNotificationDto, StudySubmittedNotificationDto } from './models/common/notification-event.model';
import { AuthService } from './services/auth.service';
import { SalesSignalrService } from './services/sales-signalr.service';
import { SignalRNotificationService } from './services/singnalr-notification.service';
import { DownloadSignalrService } from './services/download-signalr.service';
import { LoginModel } from 'src/app/models/legacy';
import { EventsEmitter } from './shared/event-emitter/EventEmitter';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isSideBarOpen: boolean = false;
  public routingUrl: string;
  isAuthenticated: boolean = false;
  urlConditionMet = false;
  isShareStudyUrl = false;
  public top_menu_bar = 'top_menu_bar';
  public isFooterNoLeftMargin: boolean = false;
  currentComponent: string | null = null;
  public isNavPropertiesEnabled: boolean = true;
  private hiddenRoutes: string[] = ['/shareStudy', '/granted', '/recovery']; // Add routes to hide sidebar
  public screenHeight;
  public screenWidth;
  public isMobileScreen: boolean = false;
  public user: LoginModel;

  public constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly salesSignalRService: SalesSignalrService,
    private readonly signalRNotificationService: SignalRNotificationService,
    private readonly downloadSignalRService: DownloadSignalrService,
    private readonly eventsEmitter: EventsEmitter
  ) {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    if (this.screenWidth < 567) {
      this.isMobileScreen = true;
    }
    this.detectCurrentComponent();
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((value) => {
        this.routingUrl = value.url;
        this.IsShareStudyUrl();
        this.urlConditionMet =
          this.routingUrl === '/' ||
          this.routingUrl === '/register' ||
          this.routingUrl === '/forgot-password' ||
          this.IsGrantedUrl() ||
          this.IsRecoveryUrl();
        const currentUrl = this.router.url; // Get the current route immediately
        this.isNavPropertiesEnabled = !this.hiddenRoutes.some(route => currentUrl.includes(route));

        // set 0 margin on stats page when opened for end user
        if (!this.isAuthenticated && this.routingUrl.includes('/statistics/sale')) {
          this.top_menu_bar = 'top_menu_bar_0m';
          this.isFooterNoLeftMargin = true;
        }
      });

   
  }

  public get showNavigation(): boolean {
    if (this.isMobileScreen && this.currentComponent === 'StatisticsComponent') {
      return false;
    }
    return true;
  }

  private detectCurrentComponent(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const child = this.getChild(this.activatedRoute);
        if (child && child.routeConfig && child.routeConfig.component) {
          this.currentComponent = child.routeConfig.component.name; // Component class name
        } else {
          this.currentComponent = null;
        }
      });
  }

  // Helper to get the deepest child route
  private getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
    while (activatedRoute.firstChild) {
      activatedRoute = activatedRoute.firstChild;
    }
    return activatedRoute;
  }

  async ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated();
    this.authService.getUserData().subscribe((data) => {
      if (data) {
        this.user = JSON.parse(data);
      }
    });
    const token = this.authService.getToken();
    
    // Start Sales SignalR connection
    if (!this.salesSignalRService.isConnected() && token && this.isAuthenticated) {
      const connected = await this.salesSignalRService.startConnection(token)
      if (connected) {
        this.salesSignalRService.onStudySubmitted((notification: NotificationEvent<StudySubmittedNotificationDto>) => {
          this.signalRNotificationService.receive(notification);
          this.eventsEmitter.onStudySubmitted.emit(notification);
        });
        this.salesSignalRService.onSaleRequested((notification: NotificationEvent<SaleRequestNotificationDto>) => {
          this.signalRNotificationService.receive(notification);
          this.eventsEmitter.onSaleRequested.emit(notification);
        });
        this.salesSignalRService.onSaleResult((notification: NotificationEvent<any>) => {
          if (this.user?.userId !== notification.scope.userId) {
            this.signalRNotificationService.receive(notification);
            this.eventsEmitter.onSaleResult.emit(notification);
          }
        });
      }
    }

    // Start Download SignalR connection
    if (!this.downloadSignalRService.isConnected() && token && this.isAuthenticated) {
      const connected = await this.downloadSignalRService.startConnection(token);
      if (connected) {

        this.downloadSignalRService.onDownloadStatusUpdate((notification) => {
          if (notification.notificationAlert.notifyUser && notification.action === NotificationAction.Completed) {
            this.signalRNotificationService.receive(notification); // Receive notification in top menu
            this.eventsEmitter.emitOnDownloadComplete(notification); // this event for completetion of task
          }

          if (!notification.notificationAlert.notifyUser && notification.action === NotificationAction.Completed) {
            this.eventsEmitter.emitOnDownloadStatusUpdate(notification); // update the grid only
          }
          if (notification.notificationAlert.notifyUser && notification.action === NotificationAction.Cancelled) {
            this.signalRNotificationService.receive(notification); 
            this.eventsEmitter.emitOnDownloadCancelled(notification);
          }
          if (notification.notificationAlert.notifyUser && notification.action === NotificationAction.Denied) {
            this.signalRNotificationService.receive(notification);
            this.eventsEmitter.emitOnDownloadError(notification);
          }
        });
      }
    }

  }



  @HostListener('window:beforeunload', ['$event'])
  doBeforeUnload(): void {
    this.salesSignalRService.forceCloseConnection();
    this.downloadSignalRService.forceCloseConnection();
  }

 

  IsGrantedUrl(): boolean {
    if (this.routingUrl && this.routingUrl.includes('/granted')) {
      return true;
    }
    return false;
  }
  IsRecoveryUrl(): boolean {
    if (this.routingUrl && this.routingUrl.includes('/recovery')) {
      return true;
    }
    return false;
  }
  IsShareStudyUrl(): void {
    if (this.routingUrl && this.routingUrl.includes('/shareStudy')) {
      this.top_menu_bar = '';
      this.isShareStudyUrl = true;
    }
    this.isShareStudyUrl = false;
  }
  public isSideBarOpenEvent($event: { isSideBarOpen: boolean }): void {
    this.isSideBarOpen = $event.isSideBarOpen;
  }
}
